module.exports = __webpack_public_path__ + "img/portrait02.6d6377c1.png";